import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ApprovalsEquipmentsApi } from '@core/api/approvals-equipments/approvals-equipments.api';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import english from './../../i18n/en.json';
import spanish from './../../i18n/es.json';
import portuguese from './../../i18n/pt.json';
var DialogApprovalsEquipmentsRejectComponent = /** @class */ (function () {
    function DialogApprovalsEquipmentsRejectComponent(approval, matDialogRef, fuseTranslationLoaderService, fuseProgressBarService, approvalsEquipmentsApi, customMessageService, formBuilder) {
        this.approval = approval;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.approvalsEquipmentsApi = approvalsEquipmentsApi;
        this.customMessageService = customMessageService;
        this.formBuilder = formBuilder;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.rejectForm = this.formBuilder.group({
            message: ['', Validators.required]
        });
    }
    DialogApprovalsEquipmentsRejectComponent.prototype.rejectApproval = function () {
        var _this = this;
        this.fuseProgressBarService.show();
        this.approvalsEquipmentsApi
            .refuseEquipment(this.approval.id, this.rejectForm.value.message)
            .subscribe(function (refusedApproval) {
            _this.fuseProgressBarService.hide();
            if (refusedApproval) {
                _this.customMessageService.success('APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_SUCCESSFULLY_REJECTED');
                _this.matDialogRef.close(true);
            }
        });
    };
    return DialogApprovalsEquipmentsRejectComponent;
}());
export { DialogApprovalsEquipmentsRejectComponent };
